var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomReportText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 252,
    viewBox: "0 0 364 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 363,
    height: 251,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 363,
    height: 251,
    rx: 7.5,
    stroke: "#E1E6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1431 24.1797V32H24.7949V24.1797H26.1431ZM29.3335 27.6011V28.6699H25.7993V27.6011H29.3335ZM29.7793 24.1797V25.2539H25.7993V24.1797H29.7793ZM31.8848 27.2949V32H30.5903V26.1885H31.8257L31.8848 27.2949ZM33.6626 26.1509L33.6519 27.354C33.5731 27.3397 33.4871 27.3289 33.394 27.3218C33.3045 27.3146 33.215 27.311 33.1255 27.311C32.9035 27.311 32.7083 27.3433 32.54 27.4077C32.3717 27.4686 32.2303 27.5581 32.1157 27.6763C32.0047 27.7909 31.9188 27.9305 31.8579 28.0952C31.797 28.2599 31.7612 28.4443 31.7505 28.6484L31.4551 28.6699C31.4551 28.3047 31.4909 27.9663 31.5625 27.6548C31.6341 27.3433 31.7415 27.0693 31.8848 26.833C32.0316 26.5967 32.2142 26.4123 32.4326 26.2798C32.6546 26.1473 32.9106 26.0811 33.2007 26.0811C33.2795 26.0811 33.3636 26.0882 33.4531 26.1025C33.5462 26.1169 33.616 26.133 33.6626 26.1509ZM36.9282 32.1074C36.4985 32.1074 36.11 32.0376 35.7627 31.8979C35.4189 31.7547 35.1253 31.556 34.8818 31.3018C34.6419 31.0475 34.4575 30.7485 34.3286 30.4048C34.1997 30.061 34.1353 29.6904 34.1353 29.293V29.0781C34.1353 28.6234 34.2015 28.2116 34.334 27.8428C34.4665 27.474 34.6509 27.1589 34.8872 26.8975C35.1235 26.6325 35.4028 26.4302 35.7251 26.2905C36.0474 26.1509 36.3965 26.0811 36.7725 26.0811C37.1878 26.0811 37.5513 26.1509 37.8628 26.2905C38.1743 26.4302 38.4321 26.6271 38.6362 26.8813C38.8439 27.132 38.9979 27.431 39.0981 27.7783C39.202 28.1257 39.2539 28.5088 39.2539 28.9277V29.481H34.7637V28.5518H37.9756V28.4497C37.9684 28.217 37.9219 27.9985 37.8359 27.7944C37.7536 27.5903 37.6265 27.4256 37.4546 27.3003C37.2827 27.175 37.0535 27.1123 36.7671 27.1123C36.5522 27.1123 36.3607 27.1589 36.1924 27.252C36.0277 27.3415 35.8898 27.4722 35.7788 27.644C35.6678 27.8159 35.5819 28.0236 35.521 28.2671C35.4637 28.507 35.4351 28.7773 35.4351 29.0781V29.293C35.4351 29.5472 35.4691 29.7835 35.5371 30.002C35.6087 30.2168 35.7126 30.4048 35.8486 30.5659C35.9847 30.7271 36.1494 30.8542 36.3428 30.9473C36.5361 31.0368 36.7563 31.0815 37.0034 31.0815C37.3149 31.0815 37.5924 31.0189 37.8359 30.8936C38.0794 30.7682 38.2907 30.591 38.4697 30.3618L39.1519 31.0225C39.0265 31.2051 38.8636 31.3805 38.6631 31.5488C38.4626 31.7135 38.2173 31.8478 37.9272 31.9517C37.6408 32.0555 37.3078 32.1074 36.9282 32.1074ZM42.8257 32.1074C42.396 32.1074 42.0075 32.0376 41.6602 31.8979C41.3164 31.7547 41.0228 31.556 40.7793 31.3018C40.5394 31.0475 40.355 30.7485 40.2261 30.4048C40.0972 30.061 40.0327 29.6904 40.0327 29.293V29.0781C40.0327 28.6234 40.099 28.2116 40.2314 27.8428C40.3639 27.474 40.5483 27.1589 40.7847 26.8975C41.021 26.6325 41.3003 26.4302 41.6226 26.2905C41.9448 26.1509 42.2939 26.0811 42.6699 26.0811C43.0853 26.0811 43.4487 26.1509 43.7603 26.2905C44.0718 26.4302 44.3296 26.6271 44.5337 26.8813C44.7414 27.132 44.8953 27.431 44.9956 27.7783C45.0994 28.1257 45.1514 28.5088 45.1514 28.9277V29.481H40.6611V28.5518H43.873V28.4497C43.8659 28.217 43.8193 27.9985 43.7334 27.7944C43.651 27.5903 43.5239 27.4256 43.3521 27.3003C43.1802 27.175 42.951 27.1123 42.6646 27.1123C42.4497 27.1123 42.2581 27.1589 42.0898 27.252C41.9251 27.3415 41.7873 27.4722 41.6763 27.644C41.5653 27.8159 41.4793 28.0236 41.4185 28.2671C41.3612 28.507 41.3325 28.7773 41.3325 29.0781V29.293C41.3325 29.5472 41.3665 29.7835 41.4346 30.002C41.5062 30.2168 41.61 30.4048 41.7461 30.5659C41.8822 30.7271 42.0469 30.8542 42.2402 30.9473C42.4336 31.0368 42.6538 31.0815 42.9009 31.0815C43.2124 31.0815 43.4899 31.0189 43.7334 30.8936C43.9769 30.7682 44.1882 30.591 44.3672 30.3618L45.0493 31.0225C44.924 31.2051 44.7611 31.3805 44.5605 31.5488C44.36 31.7135 44.1147 31.8478 43.8247 31.9517C43.5382 32.0555 43.2052 32.1074 42.8257 32.1074ZM51.9888 24.1797V32H50.6514V24.1797H51.9888ZM54.4434 24.1797V25.2539H48.2183V24.1797H54.4434ZM57.3921 32.1074C56.9624 32.1074 56.5739 32.0376 56.2266 31.8979C55.8828 31.7547 55.5892 31.556 55.3457 31.3018C55.1058 31.0475 54.9214 30.7485 54.7925 30.4048C54.6636 30.061 54.5991 29.6904 54.5991 29.293V29.0781C54.5991 28.6234 54.6654 28.2116 54.7979 27.8428C54.9303 27.474 55.1147 27.1589 55.3511 26.8975C55.5874 26.6325 55.8667 26.4302 56.189 26.2905C56.5112 26.1509 56.8604 26.0811 57.2363 26.0811C57.6517 26.0811 58.0151 26.1509 58.3267 26.2905C58.6382 26.4302 58.896 26.6271 59.1001 26.8813C59.3078 27.132 59.4618 27.431 59.562 27.7783C59.6659 28.1257 59.7178 28.5088 59.7178 28.9277V29.481H55.2275V28.5518H58.4395V28.4497C58.4323 28.217 58.3857 27.9985 58.2998 27.7944C58.2174 27.5903 58.0903 27.4256 57.9185 27.3003C57.7466 27.175 57.5174 27.1123 57.231 27.1123C57.0161 27.1123 56.8245 27.1589 56.6562 27.252C56.4915 27.3415 56.3537 27.4722 56.2427 27.644C56.1317 27.8159 56.0457 28.0236 55.9849 28.2671C55.9276 28.507 55.8989 28.7773 55.8989 29.0781V29.293C55.8989 29.5472 55.9329 29.7835 56.001 30.002C56.0726 30.2168 56.1764 30.4048 56.3125 30.5659C56.4486 30.7271 56.6133 30.8542 56.8066 30.9473C57 31.0368 57.2202 31.0815 57.4673 31.0815C57.7788 31.0815 58.0563 31.0189 58.2998 30.8936C58.5433 30.7682 58.7546 30.591 58.9336 30.3618L59.6157 31.0225C59.4904 31.2051 59.3275 31.3805 59.127 31.5488C58.9264 31.7135 58.6812 31.8478 58.3911 31.9517C58.1047 32.0555 57.7716 32.1074 57.3921 32.1074ZM61.7158 26.1885L62.8223 28.1167L63.9502 26.1885H65.3735L63.6118 29.0405L65.4434 32H64.02L62.8384 29.9912L61.6567 32H60.228L62.0542 29.0405L60.2979 26.1885H61.7158ZM68.9238 26.1885V27.1338H65.6475V26.1885H68.9238ZM66.5928 24.7651H67.8872V30.394C67.8872 30.5731 67.9123 30.7109 67.9624 30.8076C68.0161 30.9007 68.0895 30.9634 68.1826 30.9956C68.2757 31.0278 68.3849 31.0439 68.5103 31.0439C68.5998 31.0439 68.6857 31.0386 68.7681 31.0278C68.8504 31.0171 68.9167 31.0063 68.9668 30.9956L68.9722 31.9839C68.8647 32.0161 68.7394 32.0448 68.5962 32.0698C68.4565 32.0949 68.2954 32.1074 68.1128 32.1074C67.8156 32.1074 67.5524 32.0555 67.3232 31.9517C67.0941 31.8442 66.915 31.6706 66.7861 31.4307C66.6572 31.1908 66.5928 30.8721 66.5928 30.4746V24.7651Z",
    fill: "#3D3D3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 54,
    width: 290,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 70,
    width: 316,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 86,
    width: 179,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 117,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#E1E6ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 116,
    width: 155,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#E1E6ED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 132,
    width: 98,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 149,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#E1E6ED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 148,
    width: 131,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 178,
    width: 316,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 194,
    width: 179,
    height: 6,
    rx: 3,
    fill: "#E1E6ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomReportText);
export default __webpack_public_path__ + "static/media/customReportText.eba63db5cbc1f06bf529b7553e601906.svg";
export { ForwardRef as ReactComponent };